<template>
  <v-card class="mx-auto" flat>
    <v-toolbar color="white" dense light flat  class="d-none d-lg-block">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <!--v-spacer></v-spacer>
      <v-btn icon @click="toggleGridStyle">
        <v-icon>{{ gridStyle ? 'mdi-view-list' : 'mdi-view-grid' }}</v-icon>
      </v-btn-->
      <v-spacer v-if="options && options.length > 1"></v-spacer>
      <div class="d-flex" v-if="options && options.length > 1">
        <slot name="sorting"></slot>
      </div>
      <v-spacer></v-spacer>
      <!--v-btn icon v-if="isSearchable">
        <v-icon>mdi-magnify</v-icon>
      </v-btn-->
      <v-btn id="int-tr-trgt-8" small color="primary" v-if="isMutable" @click="createOptionDialog = true">
        <!-- <v-icon color="primary">mdi-plus-circle</v-icon> -->
        New Option
      </v-btn>

      <!-- <v-bottom-sheet v-if="compareList.length > 0" v-model="comparing" inset scrollable> -->
      <v-dialog
        v-if="compareList.length > 0"
        v-model="comparing"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-badge
            :content="compareList.length"
            overlap
            bordered
            :value="compareList.length > 0"
            :color="compareList.length >=2 ? 'success' : 'info'"
          >
            <v-btn text
              v-on="on"
              :disabled="compareList.length < 2"
              :color="compareList.length >=2 ? 'success' : 'info'"
            >
              Compare
            </v-btn>
          </v-badge>
        </template>
        <v-card>
          <v-card-text style="height: 100%;">
            <v-sheet class="text-center">
              <v-btn
                class="mt-6"
                text
                rounded
                color="error"
                @click="comparing = !comparing"
              >close</v-btn>
              <div class="my-3">
                <!-- Comparison data iterator -->
                <v-container fluid>
                  <v-data-iterator
                    :items="compareList"
                    items-per-page.sync="10"
                    hide-default-footer
                  >
                    <template v-slot:default="props">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center" v-for="optionItem in props.items" :key="optionItem.id">{{optionItem.name}}</th>
                            </tr>
                            <tr>
                              <th class="text-center" v-for="optionItem in props.items" :key="optionItem.id">
                                <div class="d-flex justify-center">
                                  <v-img :src="getOptionImgSrc(optionItem.imgSrc)" :maxWidth="computedMaxCompareImgSize" :maxHeight="computedMaxCompareImgSize" />
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th class="text-center" v-for="optionItem in props.items" :key="optionItem.id">
                                <v-btn v-if="canShortList" icon :color="optionItem.shortListed ? '#EF5350' : '#BDBDBD'">
                                  <v-icon :small="!optionItem.shortListed" @click="toggleOptionShortListed(optionItem)">mdi-heart</v-icon>
                                </v-btn>

                                <v-btn v-if="canDecide" icon :color="(chosen !== null && (optionItem.id === chosen) ) ? 'success' : 'info'">
                                  <v-icon :small="optionItem.id !== chosen" @click="toggleChosenOption(optionItem)">mdi-star</v-icon>
                                </v-btn>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="criteriaItem in criteria" :key="criteriaItem.id">
                              <td valign="top" v-for="optionItem in props.items" :key="optionItem.id">
                                <div class="pb-0">
                                  {{criteriaItem.name}}:
                                </div>
                                <div class="pt-0">
                                  <CriteriaValue v-if="optionItem.criteriaValues" :keywordOnly="criteriaItem.keywordOnly" :value="optionItem.criteriaValues[criteriaItem.id]" />
                                </div>
                              </td>
                            </tr>
                            <tr v-if="comparedOptionsHaveReasons">
                              <td valign="top" v-for="optionItem in props.items" :key="optionItem.id">
                                <div class="pb-0">
                                  <h3>
                                    <span class="success--text">Pros</span>
                                    <span class="info--text mx-1">and</span>
                                    <span class="error--text">Cons</span>
                                  </h3>
                                </div>
                                <div class="pt-0">
                                  <div v-for="reason in optionItem.optionReasons" :key="reason.id">
                                    <v-chip class="ma-2"
                                      :color="reason.isContra ? 'error' : 'success'"
                                      text-color="white"
                                    >
                                      <UserAvatar
                                        class="mr-2"
                                        :email="reason.ownerName"
                                        :size="24"
                                        :color="reason.isContra ? 'red darken-4' : 'green darken-4'"
                                      />
                                        {{ reason.reasonText }}
                                    </v-chip>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <!--v-row justify="center">
                        <v-col
                          v-for="item in props.items"
                          :key="item.name"
                          cols="12"
                          sm="6"
                          md="4"
                          lg="3"
                        >
                          <OptionCard
                            :option="item"
                            :isComparable="false"
                            :isEditable="false"
                            :criteria="criteria"
                            :isChosenOption="chosen === item.id"
                          >
                            <template v-slot:actions="slotProps">

                              <v-btn v-if="canShortList" icon :color="slotProps.option.shortListed ? '#EF5350' : '#BDBDBD'">
                                <v-icon :small="!slotProps.option.shortListed" @click="toggleOptionShortListed(slotProps.option)">mdi-heart</v-icon>
                              </v-btn>

                              <v-btn v-if="canDecide" icon :color="(chosen !== null && (slotProps.option.id === chosen) ) ? 'success' : 'info'">
                                <v-icon :small="slotProps.option.id !== chosen" @click="toggleChosenOption(slotProps.option)">mdi-star</v-icon>
                              </v-btn>

                            </template>
                          </OptionCard>
                        </v-col>
                      </v-row-->
                    </template>

                  </v-data-iterator>
                </v-container>
              </div>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- </v-bottom-sheet> -->
      <v-btn
        @click="clearCompareSelection()"
        icon
        v-if="compareList.length > 0"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-btn fab fixed bottom right v-if="isMutable && options && options.length > 0" @click="createOptionDialog = true">
      <v-icon color="primary">mdi-plus-circle</v-icon>
    </v-btn>

    <v-btn
      v-if="options && options.length > 0 && compareList.length > 1"
      fab
      fixed
      bottom
      right
      class="compare-fab-button"
      @click="comparing = true"
      :color="compareList.length > 1 ? 'success' : 'info'"
    >
      <v-badge
        :content="compareList.length"
        bordered
        :value="compareList.length > 0"
        light
        :color="compareList.length > 1 ? 'success darken-2' : 'info'"
      >
        <v-icon color="white">mdi-compare-horizontal</v-icon>
      </v-badge>
    </v-btn>


    <v-container fluid>
      <v-row dense>
       <v-col cols="12" class="d-flex flex-wrap">
         <div v-for="option in options" :key="option.id" class="option-wrapper">
         <UnscrapedOptionCard
          v-if="option.scrapeState === scrapeStates.unscraped || option.scrapeState === scrapeStates.failed"
          :option="option"
          :criteria="criteria"
          class="ma-2"
          :max-card-width="gridStyle ? maxCardWidth : maxListWidth"
          @onDelete="handleOptionDeleted(option)"
         >

         </UnscrapedOptionCard>
         <OptionCard
          v-else
          :option="option"
          :img-url="option.imgSrc"
          :criteria="criteria"
          class="ma-2"
          :max-card-width="gridStyle ? maxCardWidth : maxListWidth"
          @onDelete="handleOptionDeleted(option)"
          @onCompare="toggleCompare(option)"
          @onRequestReviewRescrape="openRescrapeDialog"
          @onReview="handleReviewOption(option)"
          @onApproved="handleApprovedOptionValues"
          @onResetScrape="handleRebuildOptionValues"
          :isNewOption="option.newlyAdded"
          :inCompareList="compareMap.has(option.id)"
          :isChosenOption="chosen === option.id"
         >
           <template v-slot:actions="slotProps">

             <v-btn v-if="canShortList" icon :color="slotProps.option.shortListed ? '#EF5350' : '#BDBDBD'">
               <v-icon :small="!slotProps.option.shortListed" @click="toggleOptionShortListed(slotProps.option)">mdi-heart</v-icon>
             </v-btn>

             <v-btn v-if="canDecide" icon :color="(chosen !== null && (slotProps.option.id === chosen) ) ? 'success' : 'info'">
               <v-icon :small="slotProps.option.id !== chosen" @click="toggleChosenOption(slotProps.option)">mdi-star</v-icon>
             </v-btn>

           </template>
         </OptionCard>
         </div>
       </v-col>
       <v-col v-if="isMutable && (!options || options.length === 0)">
         <div class="empty-list-message-container">
           <v-btn icon>
             <v-icon color="primary" @click="createOptionDialog = true">mdi-plus-circle</v-icon>
           </v-btn>
           Add options so you can start choosing between things and make your big decision!
           <div class="text-caption mt-3">An option is anything you want to consider for this decision. You can easily import an option using urls, or manual build the option details yourself.</div>
         </div>
         <slot name="empty"></slot>
       </v-col>
       <v-col v-else-if="!isMutable && (criteria && criteria.length === 0)">
         <div class="empty-list-message-container">
           This decision needs some criteria to build options from!
         </div>
         <slot name="empty"></slot>
       </v-col>
      </v-row>
    </v-container>

    <!-- New Option dialog -->
    <CreateOptionDialog
      v-model="createOptionDialog"
    />

    <ReviewScrapedOptionDialog
      v-model="reviewScrapedOptionDialog"
      :optionModel="reviewOptionData"
      @onApproved="handleApprovedOptionValues"
    />

    <!-- Rescrape Option Criteria dialog -->
    <RescrapeCriteriaDialog
      v-model="rescrapeDialog"
      :option="rescrapeOption"
      :scrapeResult="rescrapeOptionResult"
    />
  </v-card>
</template>

<script>
// import CriteriaValue from '@/components/CriteriaValue.vue'
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import 'firebase/firestore'

import axios from 'axios'

import { mapState, mapGetters } from 'vuex'

import ReviewScrapedOptionDialog from '@/components/ReviewScrapedOptionDialog.vue'
import CreateOptionDialog from '@/components/CreateOptionDialog.vue'
import RescrapeCriteriaDialog from '@/components/RescrapeCriteriaDialog.vue'
import OptionCard from '@/components/OptionCard.vue'
import UnscrapedOptionCard from '@/components/UnscrapedOptionCard.vue'
import CriteriaValue from '@/components/CriteriaValue.vue'
import UserAvatar from '@/components/UserAvatar.vue'

// Veux types
import * as DecisionTypes from '../store/types/decision'

export default {
  name: 'OptionsList',
  components: {
    CreateOptionDialog,
    ReviewScrapedOptionDialog,
    RescrapeCriteriaDialog,
    OptionCard,
    UnscrapedOptionCard,
    CriteriaValue,
    UserAvatar
  },
  props: {
    // decisionTaxon: String,
    options: Array,
    maxListWidth: {
      type: Number,
      default: 600
    },
    isMutable: {
      type: Boolean,
      default: true
    },
    // decisionCriteria: Object,
    criteriaRanges: Object
  },
  computed: {
    ...mapState({
      decisionId: state => state.decision.decisionId,
      decisionOwner: state => state.decision.owner,
      chosenOption: state => state.decision.chosenOption,
      // decisionTaxon: state => state.decision.currentTaxon,
      currentList: state => state.decision.currentList,
      decisionCriteria: state => state.decision.criteria,
      allOptions: state => state.decision.allOptions
    }),
    ...mapGetters('decision', {
        shortListCount: 'shortListCount'
    }),
    scrapeStates () {
      return Constants.SCRAPE_STATES
    },
    canShortList () {
      return this.currentList === 1
    },
    canDecide () {
      return this.currentList === 2
    },
    isSearchable () {
      return this.currentList === 1 || this.currentList === 2
    },
    maxCardWidth () {
      return this.currentList === 1 ? 250 : 350
    },
    computedMaxCompareImgSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 100
        case 'sm': return 150
        default: return 200
      }
    },
    title () {
      let res = 'All Options'
      if (this.currentList === 2) {
        res = 'Short List'
      } else if (this.currentList === 3) {
        res = 'Decided'
      }
      return res
    },
    chosen: {
      // getter
      get: function () {
        return this.chosenOption
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch('decision/toggleChosenOption', newValue)
        // this.$emit('onChoose', newValue)
      }
    },
    comparedOptionsHaveReasons () {
      let res = false
      for (var i = 0; i < this.compareList.length; i++) {
        const nextOption = this.compareList[i]
        if (nextOption.optionReasons && nextOption.optionReasons.length > 0) {
          res = true
          break
        }
      }
      return res
    },
    // shortListCount: {
    //   // getter
    //   get: function () {
    //     return this.initShortListCount
    //   },
    //   // setter
    //   set: function (newValue) {
    //     this.$emit('onShortListed', newValue)
    //   }
    // },
    criteria () {
        let res = []
        if (this.decisionCriteria) {
          res = Object.keys(this.decisionCriteria).map( (key) => {
              const criteriaItem = { ...this.decisionCriteria[key] }
              criteriaItem.id = key
              const valueRanges = this.criteriaRanges || {}
              if (valueRanges[criteriaItem.id]) {
                criteriaItem.range = valueRanges[criteriaItem.id]
              }
              return criteriaItem
          })
        }
        res.sort((a, b) => a.order - b.order)
        return res
    }
  },
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      compareMap: new Map(),
      compareList: [],
      comparing: false,
      gridStyle: true,
      reviewScrapedOptionDialog: false,
      createOptionDialog: false,
      rescrapeDialog: false,
      rescrapeOption: null,
      rescrapeOptionResult: null,
      newOptionModel: {name: '', criteriaValues: {}, criteriaValueOptions: {}},
      reviewOptionData: null,
      dataUnSubscribeCallback: null
      //showProsCons: false,
      //shortListCount: 0
    }
  },
  methods: {
    // handleNewOption: function (newOptionData) {
    //   // this.triggerOptionLearning(newOptionData)
    //   this.$emit('onNewOption', newOptionData)
    // },
    handleNewOption: async function (newOptionData) {
      // Fetch the data for the option and add to the list
      newOptionData.decisionId = this.decisionId
      newOptionData.newlyAdded = true
      this.$store.dispatch('decision/addOption', newOptionData)
    },
    handleReviewOption: function (theOption) {
      this.reviewOptionData = theOption
      this.reviewScrapedOptionDialog = true
      // if (newOptionData.scrapeState === scrapeStates.unscraped) {
      //   // Add the new option to the list while it is still scraping
      //   this.$emit('onNewOption', newOptionData)
      // } else {
      //   // Show the value building dialog for newly approved or scraped options
      //   this.buildOptionDialog = true
      // }
    },
    handleOptionDeleted: function (deletedOption) {
      this.$emit('onOptionDeleted', deletedOption)
    },
    openURL: function (url) {
      window.open(url, '_blank');
    },
    openRescrapeDialog: function (option, scrapeResult) {
      // console.log(`Got Opption ${JSON.stringify(option)} with rescrape result ${scrapeResult}`)
      this.rescrapeOption = option
      this.rescrapeOptionResult = scrapeResult
      this.rescrapeDialog = true
    },
    toggleGridStyle: function () {
      // console.log('Change grid style')
      this.gridStyle = !this.gridStyle
    },
    toggleCompare: function (optionItem) {
      if (this.compareMap.has(optionItem.id)) {
        this.compareMap.delete(optionItem.id)
      } else if (this.compareMap.size < 4) {
        this.compareMap.set(optionItem.id, true)
      }
      this.compareList = []
      this.options.forEach((item) => {
        if (this.compareMap.has(item.id)) {
          this.compareList.push(item)
        }
      })

    },
    clearCompareSelection: function () {
      this.compareMap.clear()
      this.compareList = []
      this.options.forEach((item) => {
        if (this.compareMap.has(item.id)) {
          this.compareList.push(item)
        }
      })
    },
    getOptionImgSrc: function (imgUrl) {
      let res = imgUrl || `${Constants.SCREENSHOT_CDN}/unknownimage.png`
      // if (res.indexOf('https:') !== 0) {
      //    res = `${Constants.SCREENSHOT_CDN}/notsecureimage.png`
      // }
      return res
    },
    toggleOptionShortListed: function (optionItem) {

      if (optionItem.shortListed || this.shortListCount < 4) {
        this.$store.dispatch('decision/toggleOptionShortListed', optionItem.id)
      }
    },
    toggleChosenOption: function (optionItem) {
      // T
      if (this.chosen && this.chosen === optionItem.id) {
        this.chosen = null
      } else {
        this.chosen = optionItem.id
      }
    },
    triggerOptionLearning: async function (optionModel) {
      // Find any criteria for which the user had to manually enter a value
      const learnFromUserValuesForExistingCriteria = []
      const learnFromValuesForCustomCriteria = []
      const learnFromSourceValuesForExistingCriteria = []

      let totalScrapedCriteria = 0
      let foundValueCount = 0
      let manualValueCount = 0

      // console.log(`Trigger option learn = ${JSON.stringify(optionModel)}`)
      for (let [key, value] of Object.entries(optionModel.criteriaValues)) {
        // Check type of criteria (custom or system)
        const criteriaItem = this.decisionCriteria[key]

        if (!criteriaItem.ignoreInScrape) {
          totalScrapedCriteria++
          if (value.userValue && value.userValue !== '') {
            manualValueCount++
          } else if (value.sourceValue && value.sourceIndex > -1) {
            foundValueCount++
          }
        }

        if (criteriaItem && !criteriaItem.userGenerated && optionModel.url) {
          // Learn from this situation. Existing system criteria with a user defined value
          // Push {value: { userValue: ..., sourceValue: ... }, decisionId: ..., optionUrl: ...}
          let valueOptions = []
          if (optionModel.criteriaValueOptions) {
            valueOptions = optionModel.criteriaValueOptions[key]
          }
          // Store details of values that the uesr had to enter manually
          if (value.userValue && value.userValue !== '') {
            learnFromUserValuesForExistingCriteria.push({
              decisionId: this.decisionId,
              optionId: optionModel.id,
              criteriaId: key,
              value: value,
              valueOptions: valueOptions,
              optionUrl: optionModel.url,
              hostname: new URL(optionModel.url).hostname,
              taxon: criteriaItem.taxon
            })
          }
          // Store details of values which the scrapper found and the user accepted
          else if (value.sourceValue && value.sourceIndex > -1) {
            learnFromSourceValuesForExistingCriteria.push({
              decisionId: this.decisionId,
              optionId: optionModel.id,
              criteriaId: key,
              value: value,
              valueOptions: valueOptions,
              optionUrl: optionModel.url,
              hostname: new URL(optionModel.url).hostname,
              taxon: criteriaItem.taxon
            })
          }
        } else if (criteriaItem && criteriaItem.userGenerated && optionModel.url) {
          // Learn from this situation. Custom criteria with a user defined value
          // Push {keyword: ..., value: { userValue: ..., sourceValue: ... }, decisionId: ..., optionUrl: ...}
          let valueOptions = []
          if (optionModel.criteriaValueOptions) {
            valueOptions = optionModel.criteriaValueOptions[key]
          }
          learnFromValuesForCustomCriteria.push({
            decisionId: this.decisionId,
            optionId: optionModel.id,
            criteriaId: key,
            keyword: criteriaItem.name,
            value: value,
            valueOptions: valueOptions,
            optionUrl: optionModel.url,
            hostname: new URL(optionModel.url).hostname,
            taxon: criteriaItem.taxon
          })
        }
      }

      // Make a single learn call
      const learnPayload = {uid: firebase.auth().currentUser.uid, decisionId: this.decisionId, optionId: optionModel.id, scrapedCriteriaCount: totalScrapedCriteria, foundValueCount: foundValueCount, manualValueCount: manualValueCount }
      if (learnFromUserValuesForExistingCriteria.length > 0) {
        learnPayload.learnUserValues = learnFromUserValuesForExistingCriteria
        // this.saveValueLearnings(learnFromUserValuesForExistingCriteria, 'uservalues')
      }

      if (learnFromValuesForCustomCriteria.length > 0) {
        // console.log(`Have learnFromValuesForCustomCriteria = ${JSON.stringify(learnFromValuesForCustomCriteria)}`)
        // this.saveValueLearnings(learnFromValuesForCustomCriteria, 'keywords')
        learnPayload.learnCustomCriteria = learnFromValuesForCustomCriteria
      }

      if (learnFromSourceValuesForExistingCriteria.length > 0) {
        // this.saveValueLearnings(learnFromSourceValuesForExistingCriteria, 'sourcevalues')
        learnPayload.learnSourceValues = learnFromSourceValuesForExistingCriteria
      }

      this.saveValueLearnings(learnPayload)
    },
    saveValueLearnings: async function (payload) {
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postURL = `${Constants.API_BASE_PATH}/learn`
      const body = {
        decisionId: this.decisionId,
        learnEntries: payload
      }
      // console.log(`Calling decision post current list ${JSON.stringify(body)}`)
      // Post, don't care about respones. Just a logging, no impact on the UI
      axios.post(postURL, body, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })
    },
    handleApprovedOptionValues: async function (optionModel) {
      // Then save the changes to the db
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const approveOptionValuesURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${optionModel.id}/approve`
      // Mutate state
      this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: optionModel.id, scrapeState: Constants.SCRAPE_STATES.approved}) // Mark approved immediately in the UI
      // optionModel.scrapeState = 2 // Mark approved

      // Indicate which criteria are user generated
      optionModel.userGeneratedCriteria = {}
      for (let [key, value] of Object.entries(this.decisionCriteria)) {
        // Check type of criteria (custom or system)
        if (value && value.userGenerated) {
          optionModel.userGeneratedCriteria[key] = true
        }
      }

      // console.log(`Calling option post ${JSON.stringify(this.newOptionModel)}`)
      const optionValuesBody = {...optionModel}
      // Remove properties not required for approve to keep the payload small
      delete optionValuesBody.scrapeResult
      const res = await axios.post(approveOptionValuesURL, optionValuesBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200) {
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_NEWLY_ADDED}`, {id: optionModel.id, newlyAdded: true}) // Indicate this so the URL is not immediately rechecked
        // optionModel.newlyAdded = true // Indicate this so the URL is not immediately rechecked
        // Trigger learning from the approved and not approved data
        // Wont trigger learning of the content was pushed (in which case the data might be specific to a particular state we cannot reproduce)
        if (!optionModel.contentPushed) {
          this.triggerOptionLearning(optionModel)
        }
      } else {
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: optionModel.id, scrapeState: Constants.SCRAPE_STATES.scraped}) // There was an issue, revert the approved state back to scrape
        // optionModel.scrapeState = 1 // Mark not approved
      }
    },
    handleRebuildOptionValues: async function (optionModel) {
      // Then save the changes to the db
      const userUID = firebase.auth().currentUser ? firebase.auth().currentUser.uid : null;
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postResetScrapeStateURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${optionModel.id}/criteria/scrape`
      const scrapeCriteriaList = this.criteria.filter(criteriaItem => !criteriaItem.ignoreInScrape)

      const resetScrapeBody = {
        url: encodeURI(optionModel.url),
        criteria: scrapeCriteriaList
      }
      if (userUID) {
        resetScrapeBody.uid = userUID // used to find user specific synonyms
      }

      // console.log(`Calling option post ${JSON.stringify(this.newOptionModel)}`)
      const res = await axios.post(postResetScrapeStateURL, resetScrapeBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200) {
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_NEWLY_ADDED}`, {id: optionModel.id, newlyAdded: true}) // Indicate this so the URL is not immediately rechecked
        // optionModel.newlyAdded = true // Indicate this so the URL is not immediately rechecked
        this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: optionModel.id, scrapeState: Constants.SCRAPE_STATES.unscraped}) // Unscraped
        // optionModel.scrapeState = 0 // Unscraped
      }
    },
    subscribeToDataListeners: function () {
      // Check if we have the data to create a listener and it is not already created
      if (this.decisionId && !this.dataUnSubscribeCallback) {
        // const userUID = firebase.auth().currentUser ? firebase.auth().currentUser.uid : null;
        this.dataUnSubscribeCallback = firebase.firestore().collection("decisions").doc(this.decisionId).collection("options") //.where("owner", "==", this.decisionOwner)
          .onSnapshot((snapshot) => {
              snapshot.docChanges().forEach((change) => {
                // const docData = change.doc.data()
                  if (change.type === "added") {
                      // this.options.push(doc.data().name);
                      // console.log("Added option: ", change.doc.data());
                      // Trigger adding a new option if this is not already in the list. E.g. it might have been pushed from another app or Browser Plugin.
                      let foundOption = null;
                      if (this.allOptions) {
                        foundOption = this.allOptions.find(next => next.id === change.doc.id)
                      }
                      if (!foundOption) {
                        const newOptionData = {id: change.doc.id, ...change.doc.data()}
                        this.handleNewOption(newOptionData)
                      }

                  }
                  if (change.type === "modified") {
                      // console.log("Modified option: ", change.doc.data());

                      let foundOption = null;
                      if (this.allOptions) {
                        foundOption = this.allOptions.find(next => next.id === change.doc.id)
                      }
                      if (foundOption) {
                        const modifiedData = change.doc.data()
                        // console.log(`Found exsiting modified option with contentState ${JSON.stringify(foundOption.contentState)} new state = ${JSON.stringify(modifiedData.contentState)}`)
                        if (
                          (foundOption.scrapeState === Constants.SCRAPE_STATES.unscraped ||
                            foundOption.scrapeState === Constants.SCRAPE_STATES.scraping) &&
                          modifiedData.scrapeState === Constants.SCRAPE_STATES.scraped) {
                          // console.log(`Finished scrape`)
                          let scrapeResult = modifiedData.scrapeResult
                          const newImageOptions = scrapeResult && scrapeResult.imageOptions ? scrapeResult.imageOptions : [{url: modifiedData.imgSrc, ranking: 1, position: 1}];

                          if (!scrapeResult) {
                            scrapeResult = {
                              url: modifiedData.url,
                              title: modifiedData.name,
                              sha256: modifiedData.sha256,
                              imageOptions: newImageOptions //[{url: modifiedData.imgSrc, ranking: 1, position: 1}]
                            }
                          }

                          this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_DATA}`, {
                            id: foundOption.id,
                            name: modifiedData.name,
                            imgSrc: modifiedData.imgSrc,
                            sha256: modifiedData.sha256,
                            scrapeResult: scrapeResult,
                            criteriaValues: modifiedData.criteriaValues,
                            criteriaValueOptions: modifiedData.criteriaValueOptions,
                            scrapeState: modifiedData.scrapeState,
                            contentPushed: modifiedData.contentPushed
                          })
                        }
                        else if (foundOption.scrapeState === Constants.SCRAPE_STATES.validating && modifiedData.scrapeState === Constants.SCRAPE_STATES.approved) {
                          // console.log(`Found condition changing from validating to approved`)
                          const checkedValuesScrapeResult = modifiedData.rescrapeResult
                          const newSha256 = checkedValuesScrapeResult.sha256
                          const newValues = checkedValuesScrapeResult.newValues || null
                          // console.log(`New Values = ${JSON.stringify(newValues)}`)
                          let foundValueDifferences = false

                          if (newValues && !(Object.keys(newValues).length === 0 && newValues.constructor === Object)) {
                            foundValueDifferences = true
                          }

                          // Update option sha256 if none have changed, otherwise do not.
                          if (foundValueDifferences) {
                            console.log(`Found value differences`)
                            // this.lastScrapeStatus = this.urlStates.changed
                            this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: foundOption.id, scrapeState: modifiedData.scrapeState})
                            this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_RE_SCRAPE_RESULT}`, {
                              id: foundOption.id,
                              rescrapeResult: checkedValuesScrapeResult
                            })

                          } else if (newSha256 && foundOption.sha256 !== newSha256) {
                            // console.log(`No new values`)
                            this.updateSHA256(foundOption.id, newSha256, modifiedData.contentState)
                            this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: foundOption.id, scrapeState: modifiedData.scrapeState})
                          }
                        }
                        else if (foundOption.scrapeState === Constants.SCRAPE_STATES.unscraped && modifiedData.scrapeState === Constants.SCRAPE_STATES.failed) {
                          this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_SCRAPE_STATE}`, {id: foundOption.id, scrapeState: modifiedData.scrapeState})
                        }

                        else if (foundOption.contentState && modifiedData.contentState && modifiedData.contentState.checkedAt > foundOption.contentState.checkedAt) {
                          this.$store.commit(`decision/${DecisionTypes.MUTATION_UPDATE_CONTENT_STATE}`, {id: foundOption.id, contentState: modifiedData.contentState})
                          this.$store.commit(`decision/${DecisionTypes.MUTATION_UPDATE_OPTION_CHECKED_TIME}`, {id: foundOption.id, lastCheckTime: modifiedData.contentState.checkedAt})
                        }
                      }
                  }
                  if (change.type === "removed") {
                      console.log("Removed option: ", change.doc.data());
                      // if (itemIndex > -1) {
                      //   this.options.splice(itemIndex, 1);
                      // }
                  }
              });
          });
      }
    },
    unsbscribeFromDataListeners: function () {
      if (this.dataUnSubscribeCallback) {
        this.dataUnSubscribeCallback()
        this.dataUnSubscribeCallback = null
      }
    },
    updateSHA256: async function (optionId, newSha256, newContentState) {
      // Save new sha256
      // console.log(`Updating SHA 256`)
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewSha256URL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/options/${optionId}/sha256`
      const postSha256Body = {sha256: newSha256}
      // console.log(`Calling option post sha256 ${JSON.stringify(postSha256Body)}`)
      axios.post(postNewSha256URL, postSha256Body, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      this.$store.commit(`decision/${DecisionTypes.MUTATION_OPTION_HASH}`, {id: optionId, sha256: newSha256})
      this.$store.commit(`decision/${DecisionTypes.MUTATION_UPDATE_OPTION_CHECKED_TIME}`, {id: optionId, lastCheckTime: Date.now()})
      this.$store.commit(`decision/${DecisionTypes.MUTATION_UPDATE_CONTENT_STATE}`, {id: optionId, contentState: newContentState})
    }
  },
  watch: {
    options: function (value, mutation) {
        if (mutation) {
          this.compareMap = new Map();
          this.compareList = [];
          this.comparing = false;
        }
    }
  },
  mounted: function () {
    this.subscribeToDataListeners()
  },
  beforeDestroy: function () {
    // Unsubscribe
    this.unsbscribeFromDataListeners()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.v-card__title {
  font-size: 1rem;
  position: relative;
}
.compare-fab-button {
  margin-bottom: 80px;
}
.option-wrapper {
  max-width: 100%;
}
</style>
